import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/teacher-man-2.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4074c374"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "app",
  class: "flex flex-col h-screen w-full max-w-7xl mx-auto bg-white shadow-lg relative -mb-8"
}
const _hoisted_2 = { class: "bg-white shadow-sm flex items-center p-4 sticky top-0 z-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-4 w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Profile Image",
    class: "w-20 h-20 rounded-full object-cover"
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold" }, "Mustafa Öztürk"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, "Matematik Öğretmeni")
  ])
], -1))
const _hoisted_4 = { class: "text-gray-800 p-4 flex sm:text-right sm:flex-1 justify-end" }
const _hoisted_5 = {
  class: "flex-1 p-4 overflow-y-auto space-y-4 scrollbar-hide",
  ref: "chatWindowRef"
}
const _hoisted_6 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_7 = { class: "bg-indigo-500 text-white p-3 rounded-l-lg rounded-br-lg max-w-sm shadow-md" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = {
  key: 1,
  class: "flex justify-start"
}
const _hoisted_10 = { class: "bg-gray-100 p-3 rounded-r-lg rounded-bl-lg max-w-sm shadow-md" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "flex justify-center my-4" }
const _hoisted_13 = { class: "bg-gray-100 p-4 border-t border-gray-200 flex items-center space-x-4 fixed bottom-0 w-full max-w-7xl mx-auto" }
const _hoisted_14 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
}
const _hoisted_15 = { class: "bg-white p-6 rounded-lg shadow-lg max-w-sm w-full" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Settings", -1))
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSpinnerDots = _resolveComponent("VueSpinnerDots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSettingsDialog && _ctx.openSettingsDialog(...args))),
          class: "focus:outline-none"
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.Cog6ToothIcon), {
            class: "h-6 w-6 text-gray-800 hover:text-indigo-600",
            "aria-hidden": "true"
          }))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['message', message.sender])
        }, [
          (message.sender === 'user')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(message.text), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(message.text), 1)
                ])
              ]))
        ], 2))
      }), 128)),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.isWaitingResponse)
          ? (_openBlock(), _createBlock(_component_VueSpinnerDots, {
              key: 0,
              size: "32",
              class: "text-gray-400"
            }))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.question) = $event)),
        placeholder: "Mesajınız...",
        class: "flex-grow p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.question]
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
        class: "bg-gray-900 text-white px-6 py-3 rounded-full shadow-md hover:bg-blue-600"
      }, " Gönder ")
    ]),
    (_ctx.showSettingsDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", _hoisted_17, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createThread && _ctx.createThread(...args))),
                disabled: _ctx.isRecording,
                class: "bg-gray-900 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600"
              }, "Create Thread", 8, _hoisted_18),
              _createTextVNode(" " + _toDisplayString(_ctx.threadId), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeSettingsDialog && _ctx.closeSettingsDialog(...args))),
              class: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            }, " Close ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}